<template>
  <div id="my-plan-container">
    <div class="content-heading">
      <i class="ic-head-icon">
        <MyPlanIcon fill="#FF6B00" />
      </i>
      <h4 class="head-title">
        {{ page_title }}
      </h4>
      <i class="ic-tooltip" id="help-fulfillment"></i>
      <b-popover target="help-fulfillment" triggers="hover" content="">
      </b-popover>
      <app-tab :tabs="tabs"></app-tab>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

import AppTabs from "@/components/common/AppTabs";
import MyPlanIcon from "@/components/my-plan/my-plan-icon";

export default {
    name: "MyPlanPage",
    components: { "app-tab": AppTabs, MyPlanIcon },
    data() {
        return {
            page_title: "My Plan"
        };
    },
    computed: {
        ...mapState("myPlan", ["tabs"]),
    },
};
</script>

<style lang="scss">
#my-plan-container {
    font-family: MainFontRegular, sans-serif;
    .myplan-form-header {
        font-size: 20px;
        font-weight: normal;
        font-family: MainFontBold, sans-serif;
        color: #2f3941;
        & + p {
            color: #87929d;
            font-size: 16px;
        }
    }
    .contents {
        .rounded {
            border-radius: 10px !important;
        }
        .shadow {
            box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.09) !important;
        }
        .box-title {
            font-size: 18px;
            font-weight: normal;
            font-family: MainFontBold, sans-serif;
        }
    }
}
</style>
